import { useEffect, useState } from "react";
import {
  fetchTicketDetails,
  fetchTicketNotes,
  fetchTicketStatus,
  postTicketNotes,
  updateTicketStatus,
} from "../../../actions/admin/tickets";
import { useParams } from "react-router-dom";
import userSVG from "../../../utils/assets/profile.svg";
import "../leads.css";
import { generateInvoice } from "../../../actions/admin/invoice";
import { toast } from "react-toastify";
import StatusSelector from "../../../components/admin/StatusSelector";
import AdminComments from "../../../components/admin/AdminComments";
const AdminTicketsPage = () => {
  const [ticketData, setTicketData] = useState([]);
  const { id } = useParams();
  const [ticketStatus, setTicketStatus] = useState([]);
  const [notesDetails, setNotesDetails] = useState([]);
console.log("ticketData", ticketData);
  useEffect(() => {
    const token = localStorage.getItem("token");
    fetchTicketDetails(token, id).then((res) => {
      setTicketData(res.data);
    });
    fetchTicketStatus(token).then((res) => {
      setTicketStatus(res.data);
    });
    fetchTicketNotes(token, id).then((res) => {
      setNotesDetails(res.data);
      console.log("notes", res.data);
    });
  }, []);

  const handleStatusChange = (data, item) => {
    const token = localStorage.getItem("token");
    const update = {
      ticket_id: item.id,
      status: data.id,
    };
    updateTicketStatus(token, update).then((res) => {
      console.log("api...", res);
    });
  };

  function filterStatusData(items) {
    return ticketStatus.find((item) =>
      item?.title?.toLowerCase().includes(items.toLowerCase())
    );
  }

  const handleComments = async (note, boolValue) => {
    const token = localStorage.getItem("token");

    const data = {
      ticket_id: id,
      note,
      is_internal: boolValue,
    };

    await postTicketNotes(token, data).then((res) => {
      if (res.success == true) {
        toast.success("Note Added Successfully");
        fetchTicketNotes(token, id).then((res) => {
          setNotesDetails(res.data);
          console.log("notes", res.data);

        });
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const handleInvoiceGenerate = () => {
    const token = localStorage.getItem("token");

    generateInvoice(id, token).then((res) => {
      if (res.success) {
        toast.success(res.data);
      } else {
        toast.error("Something went wrong");
      }
      console.log("res....", res);
    });
  };

  return (
    <div className="container-fluid mt-2 bg_color_gray">
      <div className="row">
        <div className=" d-flex justify-content-between align-items-center">
          <div>
            <button
              className="btn bg-black  text-white"
              onClick={() => handleInvoiceGenerate()}
            >
              Make Invoice
            </button>
            <button className="btn bg-black  text-white mx-2">
              Make New Ticket
            </button>
            <button className="btn bg-black  text-white">Print</button>
          </div>
          <div>
            <button className="btn bg-black text-white ">
              Mark as Rush Job
            </button>
            <button className="btn bg-black text-white mx-2">Edit Job</button>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <div className="card  card_radius p-3">
            <p className=" txt-head mb-0">Customer Details</p>
            <hr className="mt-1" />
            <div className="d-flex">
              <div className="mx-2">
                <div
                  className=""
                  style={{ border: "1px solid black", borderRadius: "50%" }}
                >
                  <img className="" width={80} src={userSVG} alt="" />
                </div>
              </div>
              <div className="mx-3">
                <p
                  className="mb-1 text-success"
                  style={{ fontSize: "21px", fontWeight: "600" }}
                >
                  {ticketData?.lead?.customer?.first_name}{" "}
                  {ticketData?.lead?.customer?.last_name}
                </p>
                <p className="mb-0 ">
                  Mobile: {ticketData?.lead?.customer?.phone}
                </p>
                <p className="mb-0 ">
                  Email: {ticketData?.lead?.customer?.email}
                </p>
                <p className="mb-0 ">
                  Address: {ticketData?.lead?.customer?.address}{" "}
                  {ticketData?.lead?.customer?.city}
                  {", "}
                  {ticketData?.lead?.customer?.state}
                  {", "}
                  {ticketData?.lead?.customer?.country}
                </p>
                <p className="mb-0 ">
                  Customer Group:{" "}
                  {ticketData?.lead?.customer?.customer_group?.name}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div className="card   card_radius p-3">
            <p className=" txt-head mb-0">Ticket Summary</p>
            <hr className="mt-1" />
            <div>
              <table className="table table-bordered mb-0">
                <tbody>
                  <tr>
                    <td>
                      <span className="">Ticket ID/Number:</span>
                    </td>
                    <td>
                      <span class="badge text-bg-success px-3 py-2">
                        {ticketData?.ticket_id}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className=" ">Created on:</span>
                    </td>
                    <td>
                      <span className=" ">
                        {ticketData?.created_at
                          ? new Date(ticketData?.created_at).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )
                          : "-"}{" "}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className=" ">Location:</span>
                    </td>
                    <td>
                      <span className=" ">Repair Book</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className=" ">Generated by:</span>
                    </td>
                    <td>
                      <span className=" ">Admin Team</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className=" ">Source:</span>
                    </td>
                    <td>
                      <span className=" ">Web App</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* <p className='mb-0'>Ticket Number: {ticketData?.ticket_id}</p>
                <p className='mb-0'>Created on: {ticketData?.lead?.customer?.phone}</p>
                <p className='mb-0'>Location: {ticketData?.lead?.customer?.email}</p>
                <p className='mb-0'>Generated By: {ticketData?.lead?.customer?.email}</p>
                <p className='mb-0'>Source: {ticketData?.lead?.customer?.email}</p> */}
            </div>
          </div>
        </div>
      </div>
      <div className="  my-3">
        <div className=" bg-white border_bg_col overflow-hidden">
          <p className="txt-head bg-dark text-light px-3 p-2 mb-0">
            Labor/Service Details
          </p>
          <table className="table table-hover">
            <thead>
              <tr>
                <td className="px-3">Service Information</td>
                <td>Diagnostic Notes</td>
                <td>Repair Status</td>
                <td>Repair Time</td>
                <td>Assigned To</td>
                <td>Due on</td>
                <td>QTY</td>
                <td>Fix Amount</td>
                <td>VAT</td>
                <td>Actions</td>
              </tr>
            </thead>
            <tbody>
              <tr className="f-16">
                <td className="px-3">
                  {ticketData?.lead?.lead_items[0]?.brand?.name}{" "}
                  {ticketData?.lead?.lead_items[0]?.devices[0]?.title}
                </td>
                <td>{ticketData?.lead?.lead_items[0]?.defects[0]?.title}</td>
                <td>
                  {ticketData?.status && ticketStatus.length > 0 && (
                    <StatusSelector
                      value={filterStatusData(ticketData?.status)}
                      Data={ticketStatus}
                      handleChange={handleStatusChange}
                      item={ticketData}
                    />
                  )}
                </td>
                <td>
                  {ticketData?.repair_time ? ticketData?.repair_time : "-"}
                </td>
                <td>
                  {ticketData?.assigned_to ? ticketData?.assigned_to : "-"}
                </td>
                <td>{ticketData?.due_on ? ticketData?.due_on : "-"}</td>
                <td>{ticketData?.qty}</td>
                <td>£ {parseFloat(ticketData?.total_price).toFixed(2)}</td>
                <td> £ {parseFloat(ticketData?.total_tax).toFixed(2)}</td>
                <td>Actions</td>
              </tr>
            </tbody>
          </table>
          <div className="card_radius total_card  d-flex flex-column justify-content-center text-end p-3 f-16 ">
            <div className="d-flex justify-content-between align-items-center">
              <span>Sub Total :</span>
              <span>£ {ticketData?.total_price}</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span>Discount :</span>
              <span>£ 0.00</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span>GST :</span>
              <span>£ {ticketData?.total_tax}</span>
            </div>
            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-dark" style={{ fontSize: "20px" }}>
                Total :{" "}
              </span>
              <span className="text-dark" style={{ fontSize: "20px" }}>
                £ {ticketData?.total_price + ticketData?.total_tax}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="">
          <AdminComments
            notesData={notesDetails}
            submit={handleComments}
            header={"Ticket History"}
          />
      </div>
    </div>
  );
};

export default AdminTicketsPage;
